// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wPkW","type":"styles_type__1CDoe","choices":"styles_choices__bcUca"};